// Who is using the app, and whether the visitor has already chosen to get started (so the landing page is only the
// front door for people who haven't).
//
// On Cloudflare (sketchy.video) sign-in is real: GET /api/me says who is signed in (worker/index.ts), and signing in
// goes to Google and comes back to the same page. Visitors who haven't signed in are guests there, with their own
// space, until their first paid action. The Bun dev server has no /api/me, so a MOCK account kept in localStorage
// stands in: signing in stores a made-up person and nothing is checked or sent anywhere.
export type Account = { name: string; email: string };
const ACCOUNT = "sketchy-account";
const STARTED = "sketchy-started";

type Me = { user: { name: string | null; email: string } | null; signIn?: string };
let me: Me | null = null; // null: no real sign-in here (the dev server)

// Asked once, before anything else, so a new visitor's guest cookie is set before the first save.
export async function loadAccount() {
  try {
    const res = await fetch("/api/me");
    if (res.ok && res.headers.get("content-type")?.includes("json")) me = (await res.json()) as Me;
  } catch {}
}

// Off to Google sign-in, coming back to `next` (this page by default) afterwards.
export function goSignIn(url = me?.signIn ?? "/auth/google", next = location.pathname + location.search + location.hash) {
  location.assign(`${url}?next=${encodeURIComponent(next)}`);
}

export function account(): Account | null {
  if (me) return me.user && { name: me.user.name ?? me.user.email, email: me.user.email };
  try {
    const a = JSON.parse(localStorage.getItem(ACCOUNT) ?? "null") as Account | null;
    return a && typeof a.name === "string" && typeof a.email === "string" ? a : null;
  } catch { return null; }
}
// True when signed in now (the mock). With real sign-in this leaves the page for Google instead, and says false.
// `next`: where to land after Google (this page by default).
export function signIn(next?: string): boolean {
  if (me) { goSignIn(undefined, next); return false; }
  try { localStorage.setItem(ACCOUNT, JSON.stringify({ name: "You", email: "you@example.com" } satisfies Account)); } catch {}
  return true;
}
export function signOut() {
  if (me) { location.assign("/auth/logout"); return; }
  try { localStorage.removeItem(ACCOUNT); } catch {}
}

export function hasStarted(): boolean {
  try { return localStorage.getItem(STARTED) === "1"; } catch { return false; }
}
export function markStarted() {
  try { localStorage.setItem(STARTED, "1"); } catch {}
}
export function clearStarted() {
  try { localStorage.removeItem(STARTED); } catch {}
}
